/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friendprofileblockmessage3Inputs */



/**
* | output |
* | --- |
* | "This user will be added to your blacklist, available from the Profile page." |
*
* @param {Friendprofileblockmessage3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const friendprofileblockmessage3 = /** @type {((inputs?: Friendprofileblockmessage3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friendprofileblockmessage3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This user will be added to your blacklist, available from the Profile page.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este usuario se añadirá a tu lista negra, disponible en la página de Perfil.")
	return /** @type {LocalizedString} */ ("Пользователь попадет в черный список, который доступен в разделе «Профиль».")
});
export { friendprofileblockmessage3 as "friendProfileBlockMessage" }